<p class="form-rgdp-info">
  {{ info }}
  <ng-content></ng-content>
</p>
